/* Warwolf — indice automatico de las paginas legales.
   Lee los h2 del cuerpo, les pone ancla y construye la navegacion.
   Al escribir la pagina no hay que tocar HTML. */
(function () {
  'use strict';

  function slug(t) {
    return t.toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 60) || 'seccion';
  }

  function build(root) {
    var body = root.querySelector('[data-ww-policy-body]');
    var nav = root.querySelector('[data-ww-toc]');
    var list = root.querySelector('[data-ww-toc-list]');
    if (!body || !nav || !list) return;

    var heads = body.querySelectorAll(':scope > h2');
    if (heads.length < 2) { nav.hidden = true; return; }

    var used = {};
    var links = [];

    heads.forEach(function (h) {
      var base = h.id || slug(h.textContent);
      var id = base;
      var n = 2;
      while (used[id]) { id = base + '-' + n; n++; }
      used[id] = true;
      h.id = id;

      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + id;
      a.textContent = h.textContent.trim();
      li.appendChild(a);
      list.appendChild(li);
      links.push({ a: a, h: h });
    });

    nav.hidden = false;

    // Marca la seccion visible mientras se hace scroll.
    if (!('IntersectionObserver' in window)) return;
    var current = null;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        if (current) current.classList.remove('is-active');
        var found = links.filter(function (l) { return l.h === entry.target; })[0];
        if (found) { found.a.classList.add('is-active'); current = found.a; }
      });
    }, { rootMargin: '-12% 0px -70% 0px', threshold: 0 });

    links.forEach(function (l) { io.observe(l.h); });
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-ww-policy]').forEach(function (root) {
      if (root.dataset.wwTocReady === '1') return;
      root.dataset.wwTocReady = '1';
      build(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
